var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPerfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EDEAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0787 16.4741C18.2299 16.4741 16.7263 17.9777 16.7263 19.8265C16.7263 21.6754 18.2299 23.1788 20.0787 23.1788C21.9276 23.1788 23.4312 21.6754 23.4312 19.8265C23.4312 17.9777 21.9276 16.4741 20.0787 16.4741Z",
    fill: "#281B65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5452 13.9595H26.3813C26.2783 13.9595 26.1894 13.8899 26.1634 13.7903L25.7284 12.4381C25.5155 11.5917 24.7578 11 23.8854 11H16.1146C15.2422 11 14.4845 11.5917 14.2709 12.439L13.8367 13.7894C13.8107 13.8899 13.7219 13.9595 13.6188 13.9595H11.4548C10.1004 13.9595 9 15.06 9 16.4134V24.9151C9 26.2687 10.1004 27.3691 11.4548 27.3691H28.5452C29.8996 27.3691 31 26.2687 31 24.9151V16.4134C31 15.06 29.8996 13.9595 28.5452 13.9595ZM20.0785 24.8547C17.3053 24.8547 15.05 22.5994 15.05 19.8262C15.05 17.053 17.3053 14.7976 20.0785 14.7976C22.8519 14.7976 25.1072 17.053 25.1072 19.8262C25.1072 22.5994 22.8519 24.8547 20.0785 24.8547ZM26.7834 18.15C26.3207 18.15 25.9453 17.7746 25.9453 17.3119C25.9453 16.8492 26.3207 16.4738 26.7834 16.4738C27.246 16.4738 27.6215 16.8492 27.6215 17.3119C27.6215 17.7746 27.246 18.15 26.7834 18.15Z",
    fill: "#281B65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerfil);
export default __webpack_public_path__ + "static/media/icon-perfil.f3aeeaf2386cd719d29ea9d5c30dfa62.svg";
export { ForwardRef as ReactComponent };